import { IUpload } from "../../utils/types";
import { apiManager } from "../api-manager";

export const upload = async (body: FormData) => {
  const res = await apiManager.post<IUpload>("/upload", body);
  return res;
};
